// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 16px;
}

ion-card-content {
  padding: 0 !important;
}

.printer-card {
  box-shadow: rgba(0, 0, 0, 0.12) 0px 4px 16px;
  text-align: center;
  transition: transform 0.2s ease;
  cursor: pointer;
}
.printer-card ion-icon {
  font-size: 32px;
  margin-top: 12px;
}
.printer-card h2 {
  font-size: 16px;
  font-weight: 600;
  margin-top: 8px;
}
.printer-card .muted {
  font-size: 12px;
  color: #999;
}
.printer-card:hover {
  transform: scale(1.04);
}`, "",{"version":3,"sources":["webpack://./src/app/components/printers/select-printer/select-printer.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,4CAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;AACF;AACE;EACE,eAAA;EACA,gBAAA;AACJ;AAEE;EACE,eAAA;EACA,gBAAA;EACA,eAAA;AAAJ;AAGE;EACE,eAAA;EACA,WAAA;AADJ;AAIE;EACE,sBAAA;AAFJ","sourcesContent":[".cards-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));\n  gap: 16px;\n}\n\nion-card-content {\n  padding: 0 !important;\n}\n\n.printer-card {\n  box-shadow: rgba(0, 0, 0, 0.12) 0px 4px 16px;\n  text-align: center;\n  transition: transform 0.2s ease;\n  cursor: pointer;\n\n  ion-icon {\n    font-size: 32px;\n    margin-top: 12px;\n  }\n\n  h2 {\n    font-size: 16px;\n    font-weight: 600;\n    margin-top: 8px;\n  }\n\n  .muted {\n    font-size: 12px;\n    color: #999;\n  }\n\n  &:hover {\n    transform: scale(1.04);\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
